<h4 class="wheel-bs__title typography-title flex items-center gap-4">
  <app-game-icon game="Wheel"></app-game-icon>
  Place Your Bet
</h4>
<div class="wheel-bs__inputs">
  <div class="wheel-bs--bet-input">
    <app-old-slider
      [(value)]="wheelService.betAmount"
      [min]="wheelService.MIN_BET"
      [max]="wheelService.MAX_BET"
      [uiSettings]="{
        thumbSize: '12px',
        trackHeight: '6px',
      }"
    ></app-old-slider>
    <app-input-options
      [(value)]="wheelService.betAmount"
      [icon]="sessionService.balanceIconSrc()"
      [options]="betInputOptions"
      [placeholder]="sessionService.balanceType() + ' value'"
      [settings]="{
      optionType: 'square',
      maskSettings: {
        mask: 'separator.2',
      },
    }"
    />
  </div>
  <div class="wheel-bs--bet-buttons">
    @for (item of betButtons; track $index) {
    <button
      class="button button--style-primary button--style-primary-bordered padding-x-8 rounded-4 h-32"
      (click)="item.fn()"
    >
      <app-balance-icon
        [balance]="sessionService.balanceType()"
        color="var(--yellow)"
      ></app-balance-icon>
      {{ item.label }}
    </button>
    }
  </div>
</div>

<div class="wheel-bs--bottom">
  <app-fairness-button
    [href]="
      wheelService.gameid()
        ? '/provably-fair/wheel/' + wheelService.gameid()
        : '/provably-fair/wheel'
    "
  ></app-fairness-button>
  <div class="wheel-bs--seed">
    <span class="wheel-bs--seed__title">Hash:</span>
    @let hash = wheelService.hash(); @if (hash) {
    <span
      class="wheel-bs--seed__value"
      (click)="clipboardService.copy(hash, 'Hash copied!')"
    >
      {{ hash }}
    </span>
    }
  </div>
</div>
